
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-mail",
  components: {},
})
export class IconMail extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#000000" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconMail;
